// icons
import {
  LuCoffee,
  LuCoins,
  LuFileText,
  LuLuggage,
  LuCalendarDays,
} from "react-icons/lu";
import { MdOutlineWorkHistory, MdOutlineWatchLater, MdOutlineWarning, MdOutlineEmojiEvents } from "react-icons/md";
import { paths } from "../routes/paths";
import { IRequestStatus } from "../types/requests.types";

export enum APPLICATIONS_IDENTIFIER {
  leave = "leave",
  leaveHour = "leaveHour",
  loan = "loan",
  mission = "mission",
  certificate = "certificate",
  salaryAllowance = "salaryAllowance",
  overtime = "overtime",
  employeeActionWarning = "employeeActionWarning",
  employeeActionAppreciation = "employeeActionAppreciation",
  employeeActionList = "employeeActionList",
}

export const APPLICATIONS = {
  leave: {
    type: 1,
    identifier: APPLICATIONS_IDENTIFIER.leave,
    color: "#0E6EFF",
    title: "درخواست مرخصی",
    icon: <LuCoffee />,
    path: paths.applications.leave,
    description:
      "برای دریافت مرخصی های روزانه و ساعتی را می توانید درخواست دهید.",
  },
  loan: {
    type: 2,
    identifier: APPLICATIONS_IDENTIFIER.loan,
    color: "#008626",
    title: "درخواست وام",
    icon: <LuCoins />,
    path: paths.applications.loan,
    description: "برای دریافت  وام می توانید درخواست دهید.",
  },
  salaryAllowance: {
    type: 2,
    identifier: APPLICATIONS_IDENTIFIER.salaryAllowance,
    color: "#008626",
    title: "درخواست مساعده",
    icon: <LuCoins />,
    path: paths.applications.salaryAllowance,
    description: "برای دریافت مساعده می توانید درخواست دهید.",
  },
  mission: {
    type: 3,
    identifier: APPLICATIONS_IDENTIFIER.mission,
    color: "#d500f9",
    title: "درخواست مأموریت",
    icon: <LuLuggage />,
    path: paths.applications.mission,
    description: "برای دریافت ماموریت می توانید درخواست دهید.",
  },
  certificate: {
    type: 4,
    identifier: APPLICATIONS_IDENTIFIER.certificate,
    color: "#5D25FC",
    title: "درخواست گواهی اشتغال",
    icon: <LuFileText />,
    path: paths.applications.certificate,
    description: "برای دریافت گواهی اشتغال می توانید درخواست دهید.",
  },
  overtime: {
    type: 4,
    identifier: APPLICATIONS_IDENTIFIER.overtime,
    color: "#14a37f",
    title: "درخواست اضافه کار",
    icon: <MdOutlineWorkHistory  />,
    path: paths.applications.overtime,
    description: "برای دریافت اضافه کار می توانید درخواست دهید.",
  },
  employeeActionWarning: {
    type: 5,
    identifier: APPLICATIONS_IDENTIFIER.employeeActionWarning,
    color: "#ff6b6b",
    title: "درخواست اخطار",
    icon: <MdOutlineWarning />,
    path: "/applications/employee-action/warning",
    description: "برای ثبت اخطار برای نیروی تیم خود می توانید درخواست دهید.",
    managersOnly: true,
  },
  employeeActionAppreciation: {
    type: 6,
    identifier: APPLICATIONS_IDENTIFIER.employeeActionAppreciation,
    color: "#ffd93d",
    title: "درخواست تشویق",
    icon: <MdOutlineEmojiEvents />,
    path: "/applications/employee-action/appreciation",
    description: "برای ثبت تشویق برای نیروی تیم خود می توانید درخواست دهید.",
    managersOnly: true,
  },
  employeeActionList: {
    type: 7,
    identifier: APPLICATIONS_IDENTIFIER.employeeActionList,
    color: "#9c27b0",
    title: "لیست اخطار و تشویق",
    icon: <MdOutlineEmojiEvents />,
    path: "/applications/employee-action/list",
    description: "مشاهده لیست درخواست‌های اخطار و تشویق",
    managersOnly: true,
  },
};

export const LEAVE_APPLICATIONS = {
  daily: {
    value: APPLICATIONS_IDENTIFIER.leave,
    label: "روزانه",
    icon: <LuCalendarDays />,
    color: "#0E6EFF",
    id: 2,
  },
  hourly: {
    value: APPLICATIONS_IDENTIFIER.leaveHour,
    label: "ساعتی",
    icon: <MdOutlineWatchLater />,
    color: "#F2665E",
    id: 1,
  },
};

export const APPLICATIONS_STATUS = {
  1: {
    label: "در انتظار تایید",
    value: IRequestStatus.inFlow,
    color: "warning",
  },
  2: { label: "تایید شده", value: IRequestStatus.done, color: "success" },
  3: { label: "رد شده", value: IRequestStatus.rejected, color: "error" },
  4: { label: "لغو شده", value: IRequestStatus.canceled, color: "error" },
};
export const LEAVE_APPLICATIONS_TYPES = {
  1: {
    name: "استحقاقی",
    id: 1,
  },
  2: {
    name: "استعلاجی",
    id: 2,
  },
  3: {
    name: "بدون حقوق",
    id: 3,
  },
  4: {
    name: "مرخصی بانوان",
    id: 4,
  },
};

export const REQUESTS_FILTERS: Record<APPLICATIONS_IDENTIFIER, string> = {
  leave: "مرخصی",
  leaveHour: "مرخصی ساعتی",
  mission: "ماموریت",
  certificate: "گواهی اشتفال به کار",
  loan: "وام",
  salaryAllowance: "مساعده",
  overtime: "اضافه کار",
  employeeActionWarning: "اخطار",
  employeeActionAppreciation: "تشویق",
  employeeActionList: "لیست اخطار و تشویق",
};

export const EMPLOYEE_ACTION_STATUS = {
  1: {
    label: "در انتظار بررسی",
    value: 1,
    color: "warning",
  },
  2: { label: "تایید شده", value: 2, color: "success" },
  3: { label: "رد شده", value: 3, color: "error" },
};
